export { default } from './TriggerAvatar';
